/**
 * Titles of board columns that SIMB creates and maintains itself. They are excluded
 * from every column-mapping/sharing UI: their values are derived from sync state, so
 * mapping or sharing them would just fight the services that own them.
 * Must match the titles used by the backend services (see simb-common-lib's
 * SHARED_BOARDS_COLUMN / ITEM_LOCATIONS_COLUMN constants).
 */
export const SIMB_MANAGED_COLUMN_TITLES: readonly string[] = [
  "Item Locations 🔒",
  // The app's own dropdown-column feature (simb-common-lib SHARED_BOARDS_COLUMN): users add it
  // from the column center and SIMB fills it with the names of the item's boards. Columns left
  // behind by the retired "Shared Boards Column" account setting carry the same title.
  "Shared Boards 🔒",
];

export const isSimbManagedColumnTitle = (title?: string | null): boolean =>
  SIMB_MANAGED_COLUMN_TITLES.includes(title ?? "");
